<template>
    <section class="tables new-updated-design">
        <vue-snotify></vue-snotify>
        <div class="row">
            <div class="col-lg-12 grid-margin stretch-card">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">View Modules</h4>
                    </div>
                    <div class="card-body">
                        <CircleLoader v-if="isLoading" />
                        <vue-good-table mode="remote"
                          v-else
                            :totalRows="totalRecords" :isLoading.sync="isLoading"
                            :pagination-options="{ enabled: false, dropdownAllowAll: false, perPageDropdown: [10, 20, 50, 100, 200], }"
                            :rows="rows" :sort-options="{
                                enabled: false,
                            }" :columns="columns">
                            <template slot="table-row" slot-scope="props">
                                <span v-if="props.column.field === 'action'" class="text-nowrap">
                                    <b-button size="sm" @click="editModule(props.row)" class="mr-1 btn-info text-white">
                                        Edit
                                    </b-button>
                                </span>
                                <span v-else-if="props.column.field === 'ModuleVenue'">
                                    <a
                                    @click.prevent="showMap(props.row.ModuleMap)"
                                    style="cursor: pointer; text-decoration: underline; color: blue;"
                                    >
                                        {{ props.formattedRow[props.column.field] }}
                                    </a>
                                </span>
                                <span v-else>
                                    {{ props.formattedRow[props.column.field] }}
                                </span>
                            </template>
                        </vue-good-table>
                    </div>
                </div>
            </div>
        </div>
        <div></div>
    </section>
</template>

<script>
import Vue from "vue";
import VueJsonToCsv from 'vue-json-to-csv'
import SortedTablePlugin from "vue-sorted-table";
import API from '@/api'

import moment from 'moment'
import CircleLoader from '@/pages/loaders/CircleLoader.vue'; // Adjust the path accordingly
Vue.component('vue-json-to-csv', VueJsonToCsv)
Vue.use(SortedTablePlugin, {
    ascIcon: '<i class="ti-arrow-down"></i>',
    descIcon: '<i class="ti-arrow-up"></i>'
});

export default {
    name: 'Spotters',
//     components: {
//     CircleLoader, // Register the CircleLoader component
//   },
    data() {
        return {
            isDisabled: false,
            selected: true,
            unSelected: false,
            serverParams: {
                customFilters: {
                    status: '',
                    memberStatus: '',
                    name: ''
                },
                sort: [
                    {
                        field: 'id', // example: 'name'
                        type: 'desc' // 'asc' or 'desc'
                    }
                ],

                page: 1, // what page I want to show
                perPage: 10 // how many items I'm showing per page
            },
            columns: [
                {
                    label: 'Module Name',
                    field: 'ModuleName',
                    filterable: false,
                },
                {
                    label: 'Module Number',
                    field: 'ModuleNumber',
                    sortable: false,
                },
                {
                    label: 'Description',
                    field: "ModuleDescription",
                    sortable: false,
                    formatFn: this.removePTags,
                },
                {
                    label: 'Start Date',
                    field: "ModuleStartDate",
                    sortable: false,
                    formatFn: this.formatDate
                },
                {
                    label: 'End Date',
                    field: "ModuleEndDate",
                    sortable: false,
                    formatFn: this.formatDate,
                },
                {
                    label: 'Venue',
                    field: "ModuleVenue",
                    sortable: false,
                },
                {
                    label: 'Action',
                    field: "action",
                    sortable: false,
                },
            ],
            isLoading: false,
            rows: [],
            totalRecords: 0,
            spots: [],
            CSVData: []
        };
    },
    methods: {
        editModule(module) {
            // console.log(module);
            this.$router.push({ name: 'edit_Module', params: { id: module.ModuleID, module: module } });
            // this.$router.push({name: 'edit_Module', params: {module: module}});
        },
        loadItems() {
            this.isLoading = true;
            API.getAllModules(
                data => {
                    this.totalRecords = data.totalRecords;
                    this.rows = data.data;
                    this.isLoading = false;
                }, err => {
                     this.isLoading = false;
                })
                
        },
        showMap(moduleMap) {
            // Extract the map URL from the <p> tags
            const mapUrl = moduleMap.replace(/<\/?p>/g, '');
            // Open the map URL in a new tab
            window.open(mapUrl, '_blank');
        },

        removePTags(value) {
            // console.log('tag', value)
            const regex = /<\/?p>/g; // Regular expression to match <p> tags
            return value.replace(regex, '');
        },
        formatDate(value) {
            if (value) {
                return moment(String(value)).format('MMM DD, yyyy')
            }
        },
    },
    computed: {}
    ,
    mounted() {
        this.loadItems();
    }
}
</script>
